import {AssemblyType} from "./AssemblyModel";
import {Robot} from "./Robot";
import {Monster} from "./Monster";
import {assembly as RobotItemLayout, main as RobotLayout} from "../../Layout/RobotScreenLayout";
import {assembly as MonsterItemLayout, main as MonsterLayout} from "../../Layout/MonsterScreenLayout";
import {assembly as MovieItemLayout, main as MovieLayout} from "../../Layout/MovieScreenLayout";
import {Movie} from "./Movie";

export const AssemblyItems = {
    [AssemblyType.Robot]: Robot,
    [AssemblyType.Monster]: Monster,
    [AssemblyType.Movie]: Movie,
};

export const AssemblyLayouts = {
    [AssemblyType.Robot]: RobotLayout,
    [AssemblyType.Monster]: MonsterLayout,
    [AssemblyType.Movie]: MovieLayout,
};

export const AssemblyItemLayouts = {
    [AssemblyType.Robot]: RobotItemLayout,
    [AssemblyType.Monster]: MonsterItemLayout,
    [AssemblyType.Movie]: MovieItemLayout,
};